module.exports = __webpack_public_path__ + "img/5LNG_Cover.23d3e0f1.jpg";